import {Component, Input} from '@angular/core';
import {JobErrorOutputData} from "../../../_models/jobs/job-error-output";


@Component({
    selector: 'src-job-error-output',
    templateUrl: './job-error-output.component.html',
    styleUrls: ['./job-error-output.component.less'],
    imports: [],
    standalone: true
})
export class JobErrorOutputComponent {
    @Input() outputData: JobErrorOutputData;

}
